import { exp } from "./export";
import { lang } from '../lang.js';
import { settings } from '../settings.js';

exp.getBrickWordChart = strip => { // word chart for multiple brick stitch patterns
    let result = {text: []};

    // find out how many columns we need on a given row

    let returnStackHeight = startingRow => {
        let count = 1;
        for (let i = startingRow + 1; i < exp.offsetPattern.length; i++) {
            if (exp.offsetPattern[i] == exp.offsetPattern[startingRow]) {
                count++;
            } else {
                break;
            }
        }
        return count;
    };

    // build a row (combining multiple rows)

    let returnRow = (startingRow, stackHeight, reverse) => {

        let startingNumber = startingRow + 1;
        let myRow = [];
        myRow.push(lang.caps(lang.get('row')) + ' ' + startingNumber.toString() + ': ');
        let myArrow = reverse ? '← ' : '→ ';
        result.text.push(myArrow);

        // build a stack of beads

        let getStack = (column, _reverse) => {
            let myStack = [];

            for (let i = 0; i < stackHeight; i++) {
                if (strip.rows[startingRow + i] !== undefined) {
                    let myBead = strip.rows[startingRow + i][column];
                    myStack.push(myBead);
                }
            }

            return exp.parseRow(myStack, _reverse);
        };

        let addStack = (i, shouldReverse) => {
            myRow.push('(');
            let myStack = getStack(i, shouldReverse);
            myStack.forEach(element => {
                myRow.push(element);
            });
            myRow.push(')');
        }

        if (startingRow == 0) { // build ladder stitch row
            for (let i = 0; i < settings.columns; i++) {
                addStack(i, !(i % 2 == 0));
                if (i < settings.columns - 1) {
                    myRow.push(', ');
                }
            }
        } else { // build regular brick stitch row
            let startIndex = reverse ? settings.columns - 1 : 0;
            let fn = i => reverse ? i >= 0 : i < settings.columns;
            let increment = reverse ? -1 : 1;

            let counter = 0;

            for (let i = startIndex; fn(i); i += increment) {
                addStack(i, (counter > 0));
                if (counter < settings.columns - 1) {
                    myRow.push(', ');
                }
                counter++;
            }
        }

        return myRow;
    };

    let currentRow = 0;
    let myArrow, myRow, reverse = false;

    while (currentRow < settings.rows) {
        let myStackHeight = returnStackHeight(currentRow);
        myArrow = reverse ? '← ' : '→ ';

        if (myStackHeight == 1) {
            let rowNumber = currentRow + 1;
            if (strip.rows[currentRow] !== undefined) {
                result.text.push(lang.caps(lang.get('row')) + ' ' + + rowNumber.toString() + ': ');
                result.text.push(myArrow);
                myRow = exp.parseRow(strip.rows[currentRow], reverse);
            } else {
                myRow = null;
            }
        } else {
            myRow = returnRow(currentRow, myStackHeight, reverse);
        }

        if (myRow) {
            myRow.forEach(element => {
                result.text.push(element);
            });
        }
        result.text.push('\n');
        currentRow += myStackHeight;
        reverse = !reverse;
    }

    return result;
};
